import React from 'react';
import { useLocale } from '../context/LocaleContext';
import styles from '../styles/authErrorDisplay.module.css';

interface AuthErrorDisplayProps {
  error: string;
  onLogin: () => void;
  onRefresh?: () => void;
}

/**
 * Reusable component for displaying authentication errors with clear action buttons
 * Provides consistent, user-friendly error messaging across the app
 */
export const AuthErrorDisplay: React.FC<AuthErrorDisplayProps> = ({
  error,
  onLogin,
  onRefresh,
}) => {
  const { t } = useLocale();
  return (
    <div className={styles.authErrorContainer}>
      <div className={styles.authErrorIcon}>🔒</div>
      <h3 className={styles.authErrorTitle}>{t('auth.error.title')}</h3>
      <p className={styles.authErrorMessage}>{error}</p>
      <div className={styles.authErrorActions}>
        <button onClick={onLogin} className={styles.authErrorButtonPrimary}>
          {t('auth.error.log_in_again')}
        </button>
        {onRefresh && (
          <button onClick={onRefresh} className={styles.authErrorButtonSecondary}>
            {t('ui.REFRESH_PAGE')}
          </button>
        )}
      </div>
      <p className={styles.authErrorHelp}>{t('auth.error.help_after_login')}</p>
    </div>
  );
};
